import { useForm } from 'react-hook-form';

import { TabWrap, SectionType } from 'sections/TabWrap';

import { Panel, Input } from './components/Panel';

import * as S from './Prices.styles';

export function Prices(): React.ReactElement {
  const { register } = useForm();

  const priceListInputs: Input[] = [
    {
      name: 'price',
      label: 'price',
    },
    {
      name: 'vat',
      label: 'vat',
      vatLabel: true,
    },
    {
      name: 'discount',
      label: 'discount',
    },
  ];

  const sections: SectionType[] = [
    {
      id: 1,
      content: (
        <S.PurchaseInput
          motive="m2"
          register={register}
          name="purchase_price"
          label="Purchase Price"
        />
      ),
    },
    {
      id: 2,
      content: (
        <>
          <Panel title="Public" inputs={priceListInputs} />

          <Panel title="Dealer" inputs={priceListInputs} />
        </>
      ),
    },
  ];

  return <TabWrap sections={sections} />;
}
